<div class="messages-handler-container" fxLayout="column">
  <!--SELECT USER-->
  <div fxLayoutAlign="center center">
    <mat-form-field style="width: 91%;" class="select-ship font-weight-filters">
      <input
        [(ngModel)]="searchtext"
        (keyup)="validateText()"
        matInput
        appDisableAutofill
        [matAutocomplete]="auto"
        placeholder="Select the user to chat"
      />
    </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option
        *ngFor="let member of membersFiltered"
        value="{{ member.name + ' ' + member.last_name }}"
        (click)="selectMember.emit(member)"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxLayoutAlign="center start">
            <div class="circular-logo-task">
              <img
                src="{{ member.photo | getUserPhoto }}"
                onerror="this.src='assets/images/icons/user.png'"
                alt=""
              />
              <mat-icon
                [ngClass]="{
                  'active-memeber': member.on_line === true,
                  'inactive-memeber': member.on_line === false
                }"
                >fiber_manual_record</mat-icon
              >
            </div>
          </div>
          <div fxLayout="column" class="data-company ml-3">
            <div
              class="label-color"
              fxFlex="50"
              fxLayout="row"
              fxLayoutAlign="start end"
            >
              {{ member.name + ' ' + member.last_name | titlecase }}
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
      </mat-option>
    </mat-autocomplete>
  </div>
  <!--END SELECT USER-->
  <!--RECENT CONTACTS-->
  <div class="recent-contacts" fxLayout="column">
    <span class="title-chat mb-3">Recent contacts</span>
    <div class="contacts-container" fxLayout="row">
      <div
        class="section ml-2"
        fxLayout="column"
        *ngFor="let contact of recentContacts | getRecentContacts : true"
        fxFlex="20"
        (click)="selectPreviosContact.emit(contact)"
      >
        <div fxLayoutAlign="center center">
          <div class="circular-logo-task-recent">
            <img
              src="{{
                contact.contact_photo
                  ? (contact.contact_photo | getUserPhoto)
                  : null
              }}"
              onerror="this.src='assets/images/icons/user.png'"
              alt=""
            />
            <mat-icon
              [ngClass]="{
                'active-memeber-recent': contact && contact.on_line === true,
                'inactive-memeber-recent': contact && contact.on_line === false
              }"
              >fiber_manual_record</mat-icon
            >
          </div>
        </div>
        <div
          matTooltip="{{ contact.contact_name | titlecase }}"
          fxLayoutAlign="center center"
          class="name-contact"
        >
          {{
            (contact.contact_name && contact.contact_name.length > 6
              ? contact.contact_name.slice(0, 6) + '..'
              : contact.contact_name
            ) | titlecase
          }}
        </div>
      </div>
      <div *ngIf="recentContacts.length === 0">No recent contacts ...</div>
    </div>
  </div>
  <!--END RECENT CONTACTS-->
  <!--RECENT CONVERSATIONS-->
  <div class="recent-contacts" fxLayout="column">
    <span class="title-chat mb-3">Conversations</span>
    <div class="conversation-container" fxLayout="column">
      <ng-container *ngFor="let conversation of recentContacts | getRecentContacts">
        <div
          class="section mb-2 border-custom pt-1"
          fxLayout="row"
          (click)="selectConversation.emit(conversation)"
        >
          <div fxFlex="15" fxLayoutAlign="center center">
            <div class="circular-logo-task-recent">
              <img
                src="{{
                  conversation.contact_photo
                    ? (conversation.contact_photo | getUserPhoto)
                    : null
                }}"
                onerror="this.src='assets/images/icons/user.png'"
                alt=""
              />
              <mat-icon
                [ngClass]="{
                  'active-memeber-recent': conversation.on_line === true,
                  'inactive-memeber-recent': conversation.on_line === false
                }"
                >fiber_manual_record</mat-icon
              >
            </div>
          </div>
          <div fxFlex="75" fxLayout="column">
            <span class="name-conversation">
              {{ conversation.contact_name }}</span
            >
            <span
              matTooltip="{{ conversation.lastMessage }}"
              class="message-conversation"
            >
              {{
                conversation.lastMessage && conversation.lastMessage.length > 86
                  ? conversation.lastMessage.slice(0, 86) + '...'
                  : conversation.lastMessage
              }}</span
            >
          </div>
          <div fxFlex="10" class="total" fxLayoutAlign="center center">
            <div
              class="badge"
              fxLayoutAlign="center center"
              *ngIf="conversation.unseen && conversation.emitter_id !== user.id"
            >
              {{
                conversation.unseen_msgs && conversation.unseen_msgs > 10
                  ? '9+'
                  : conversation.unseen_msgs
              }}
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="recentContacts.length === 0">No recent conversations ...</div>
    </div>
  </div>
</div>
